import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Маршрут только для авторизованных: гостя уводим на страницу входа ("/"),
// запоминая в state.from, куда он шёл, чтобы вернуть его туда после логина.
export default function PrivateRoute({ children, render, ...rest }) {
  const token = useSelector(state => state.auth.token)

  return (
    <Route
      {...rest}
      render={props => {
        if (!token) {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        }
        return render ? render(props) : children
      }}
    />
  )
}
